export default __webpack_public_path__ + "static/media/logo_buyuk_beyaz_en.b1b338ef.png";